module.exports = __webpack_public_path__ + "img/Kiribati.a6f53025.gif";